module.exports = __webpack_public_path__ + "media/application/images/img/overlays/08-975f7e0074400e7561ba2124604aacf2.png";